module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "Photograph_Sources"
    }
  }, [_c('div', {
    staticClass: "chapterHead",
    attrs: {
      "id": "chapter"
    }
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Photograph Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he author is indebted to a number of individuals who were kind enough to share their private collections and offer their expertise, in particular military historian Dr Peter Caddick-Adams, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monty and Rommel: Parallel Lives")]), _vm._v(", who made available his photographs of the Deutsches Afrika Korps; Steve Hunnisett and Paul Lazzell, whose fathers Ron and Bill served with the Royal Artillery, and Raine Alexander, whose father served with the Royal Army Service Corps in North Africa. Their photographs offer a very personal insight into the conduct of the war fought in the desert sands and mountains of North Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Preston Isaac, Chairman of the Military Vehicle Trust and owner of the Cobbaton Combat Collection, provided Basil Lancaster’s photographs taken in East Africa. Images have also been drawn from the American National Archives and Records Administration (NARA), which include the US Army and Signal Corps collections covering the North African Campaign, as well as the author’s own collection built up over the last thirty years from a wide variety of sources.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-975fd126","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_00_Photograph_Sources.vue
// module id = 72
// module chunks = 0